__turbopack_context__.v({
  "iframe-wrapper": "nBK2Hq_iframe-wrapper",
  "iframe-wrapper-external": "nBK2Hq_iframe-wrapper-external",
  "play-button": "nBK2Hq_play-button",
  "skeleton-container": "nBK2Hq_skeleton-container",
  "thumbnail-container": "nBK2Hq_thumbnail-container",
  "video-player-embed": "nBK2Hq_video-player-embed",
});
